import { nodeInfo } from './nodeInfo'
import { Cursor, CursorV } from '../lib/Cursor'
import * as Model from '../types/document'
import { network } from '../globals';

export type InputLabel = NamedInput | NumberedInput
interface NamedInput { type: 'named', name: string }
interface NumberedInput { type: 'numbered', number: number }

export const inputLabelsForCodeCall = network.valueFunc('inputLabelsForCodeCall',
  (callC: Cursor<Model.CodeCall>, blockC: Cursor<Model.Block>): Array<InputLabel> => {
    let nextNumberedInput = 1
    return CursorV.elems(callC.select('inputs').fetch()).map((inputC): InputLabel => {
      const inputNodeInfo = nodeInfo(blockC, inputC.value().outside)

      // Try to come up with a nice name
      if (inputNodeInfo.name) {
        return {type: 'named', name: inputNodeInfo.name}
      } else if (inputNodeInfo.type === 'graph') {
        const referredNodeId = inputNodeInfo.referredNodeId
        if (referredNodeId) {
          const referredNodeInfo = nodeInfo(blockC, referredNodeId)
          if (referredNodeInfo.name) {
            return {type: 'named', name: referredNodeInfo.name}
          }
        }
      }

      // Otherwise, number them
      const number = nextNumberedInput
      nextNumberedInput++
      return {type: 'numbered', number: number}
    })
  }
)



// WEBPACK FOOTER //
// ./src/model/inputLabelsForCodeCall.ts